module.exports = {
  "calendar": "\u0627\u0644\u062A\u0642\u0648\u064A\u0645",
  "day": "\u064A\u0648\u0645",
  "dayPeriod": "\u0635/\u0645",
  "endDate": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
  "era": "\u0627\u0644\u0639\u0635\u0631",
  "hour": "\u0627\u0644\u0633\u0627\u0639\u0627\u062A",
  "minute": "\u0627\u0644\u062F\u0642\u0627\u0626\u0642",
  "month": "\u0627\u0644\u0634\u0647\u0631",
  "second": "\u0627\u0644\u062B\u0648\u0627\u0646\u064A",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u062A\u0627\u0631\u064A\u062E \u0645\u062D\u062F\u062F: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u0627\u0644\u0645\u062F\u0649 \u0627\u0644\u0632\u0645\u0646\u064A \u0627\u0644\u0645\u062D\u062F\u062F: ".concat(args.startDate, " \u0625\u0644\u0649 ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u062D\u062F\u062F: ".concat(args.time);
  },
  "startDate": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621",
  "timeZoneName": "\u0627\u0644\u062A\u0648\u0642\u064A\u062A",
  "weekday": "\u0627\u0644\u064A\u0648\u0645",
  "year": "\u0627\u0644\u0633\u0646\u0629"
};